import { initializeApp } from 'firebase/app';
import {
    getAnalytics,
    isSupported,
    logEvent
} from "firebase/analytics";
import {
    getAuth,
    signInWithPopup,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    GoogleAuthProvider,
    signOut,
    onAuthStateChanged,
    sendPasswordResetEmail
} from 'firebase/auth'
import {
    getDoc,
    getDocs,
    collection,
    query,
    where,
    doc,
    getFirestore,
    setDoc,
    updateDoc,
    deleteDoc,
    addDoc,
    serverTimestamp
} from 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyBuFioM65KgYHYPIFG-o1KFULWCvzekDis",
    authDomain: "glu-mvp.firebaseapp.com",
    projectId: "glu-mvp",
    storageBucket: "glu-mvp.appspot.com",
    messagingSenderId: "341702561769",
    appId: "1:341702561769:web:2a744cb2838134c31dc578",
    measurementId: "G-4211SR9MQQ"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
const analytics = getAnalytics();

const provider = new GoogleAuthProvider();

// Conditionally enable Firebase Analytics in development
if (process.env.NODE_ENV !== 'production') {
    isSupported().then((supported) => {
        if (supported) {
            console.log('Firebase Analytics is supported');
        }
    });
}

export default app;

export { logEvent }; // Properly export logEvent and analytics

provider.setCustomParameters({
    prompt: "select_account"
})

export function trackChallengeCreation(challengeID, userID) {
    logEvent(analytics, 'challenge_created', {
        challenge_id: challengeID,
        user_id: userID,
    });
    console.log('logged: ', challengeID, "created by", userID)
}

export const auth = getAuth(app);

export const signInWithGooglePopup = () => signInWithPopup(auth, provider);

export const createUserDocumentFromAuth = async (userAuth) => {
    const userDocRef = doc(db, 'users', userAuth.uid)

    const userSnapshot = await getDoc(userDocRef)

    if (!userSnapshot.exists()) {
        const { displayName, email } = userAuth;
        const createdAt = new Date();

        try {
            await setDoc(userDocRef, {
                displayName,
                email,
                createdAt
            })
        } catch (error) {
            console.log('error creating user', error.message)
        }
    }
    return userDocRef;
};

export const signOutUser = async () => await signOut(auth);

export const signUpWithEmail = async (email, password) => {
    try {
        // Create a new user with email and password
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);

        // Optional: Create a user document in Firestore if you need to store additional data
        const user = userCredential.user;
        await createUserDocumentFromAuth(user);

        console.log('User signed up successfully:', user);
        return user;
    } catch (error) {
        console.error('Error signing up with email:', error.message);
        throw error; // Propagate error for handling
    }
};

export const signInWithEmail = async (email, password) => {
    try {
        // Sign in the user with email and password
        const userCredential = await signInWithEmailAndPassword(auth, email, password);

        // Get the authenticated user
        const user = userCredential.user;
        console.log('User signed in successfully:', user);
        return user;
    } catch (error) {
        console.error('Error signing in with email:', error.message);
        throw error; // Propagate error for handling
    }
};

export const onAuthStateChangedListener = (callback) => onAuthStateChanged(auth, callback)

export const uploadAcceptedChallenge = async (acceptedChallenge, ID) => {
    try {
        // Generate a unique ID for the document
        const uniqueID = ID;

        // Reference to the "accepted challenges" collection
        const acceptedChallengesCollectionRef = collection(db, 'acceptedChallenges');

        // Reference to the document within the collection using the unique ID
        const acceptedChallengeDocRef = doc(acceptedChallengesCollectionRef, uniqueID);

        // Upload the acceptedChallenge object to Firestore
        await setDoc(acceptedChallengeDocRef, {
            ...acceptedChallenge,
            createdAt: serverTimestamp()
        });

        console.log('Accepted Challenge uploaded successfully!');
    } catch (error) {
        console.error('Error uploading accepted challenge:', error);
    }
};

export const uploadCreatedChallenge = async (createdChallenge) => {
    try {
        // Reference to the "challenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        // Add a new document with an automatically generated ID
        const docRef = await addDoc(challengesCollectionRef, {
            ...createdChallenge,
            createdAt: serverTimestamp()
        });

        console.log('Created Challenge uploaded successfully with ID:', docRef.id);
    } catch (error) {
        console.error('Error uploading created challenge:', error);
    }
};

export const getCurrentAcceptedChallengesForUser = async (userID) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const acceptedChallengesCollectionRef = collection(db, 'acceptedChallenges');

        const today = new Date();
        today.setDate(today.getDate());

        // Construct a query to retrieve accepted challenges based on user ID and date
        const q = query(acceptedChallengesCollectionRef,
            where('userID', '==', userID), // Filter by user ID
            where('doneBoolean', '==', false)
        );

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store accepted challenges
        const acceptedChallenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            acceptedChallenges.push({ id: doc.id, ...doc.data() });
        });

        return acceptedChallenges;

    } catch (error) {
        console.error('Error retrieving accepted challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getDoneAcceptedChallengesForUser = async (userID) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const acceptedChallengesCollectionRef = collection(db, 'acceptedChallenges');

        const today = new Date();
        today.setDate(today.getDate());

        // Construct a query to retrieve accepted challenges based on user ID and date
        const q = query(acceptedChallengesCollectionRef,
            where('userID', '==', userID), // Filter by user ID
            where('doneBoolean', '==', true)
        );

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store accepted challenges
        const acceptedChallenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            acceptedChallenges.push({ id: doc.id, ...doc.data() });
        });

        return acceptedChallenges;

    } catch (error) {
        console.error('Error retrieving accepted challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getChallengesByCategory = async (category) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        // Construct a query to retrieve accepted challenges based on user ID and date
        const q = query(challengesCollectionRef,
            where('category', '==', category), // Filter by user ID
        );

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store accepted challenges
        const challenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            challenges.push({ id: doc.id, ...doc.data() });
        });

        return challenges;
    } catch (error) {
        console.error('Error retrieving challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getMyChallengesForUser = async (userId) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const myChallengesCollectionRef = collection(db, 'challenges');

        const today = new Date();
        today.setDate(today.getDate());

        // Construct a query to retrieve accepted challenges based on user ID and date
        const q = query(myChallengesCollectionRef,
            where('userID', '==', userId), // Filter by user ID
            where('channelID', '==', false) // Filter by end date greater than or equal to today's date
        );

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store accepted challenges
        const myChallenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            myChallenges.push({ id: doc.id, ...doc.data() });
        });

        return myChallenges;

    } catch (error) {
        console.error('Error retrieving my challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getPublicChallengesForUser = async (userId) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const myChallengesCollectionRef = collection(db, 'challenges');

        const today = new Date();
        today.setDate(today.getDate());

        // Construct a query to retrieve accepted challenges based on user ID and date
        const q = query(myChallengesCollectionRef,
            where('userID', '==', userId), // Filter by user ID
            where('publicFlag', '==', true) 
        );

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store accepted challenges
        const myChallenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            myChallenges.push({ id: doc.id, ...doc.data() });
        });

        return myChallenges;

    } catch (error) {
        console.error('Error retrieving my challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getChallengesForUser = async (userId) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        const today = new Date();
        today.setDate(today.getDate());

        // Construct a query to retrieve accepted challenges based on user ID and date
        const q = query(challengesCollectionRef,
            where('uniqueId_influencer', '==', userId), // Filter by user ID
            // where('channelId', '==', false) // Filter by end date greater than or equal to today's date
        );

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store accepted challenges
        const challenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            challenges.push({ id: doc.id, ...doc.data() });
        });

        return challenges;

    } catch (error) {
        console.error('Error retrieving my challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const deleteMyChallenge = async (challengeId) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        // Reference to the specific document using its ID
        const challengeDocRef = doc(challengesCollectionRef, challengeId);

        // Delete the document
        await deleteDoc(challengeDocRef);

        console.log('My challenge deleted successfully.');
    } catch (error) {
        console.error('Error deleting my challenge: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const updateAcceptedChallenge = async (challengeId, updatedData) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const acceptedChallengesCollectionRef = collection(db, 'acceptedChallenges');

        // Reference to the specific document using its ID
        const challengeDocRef = doc(acceptedChallengesCollectionRef, challengeId);

        // Update the document with the new data
        await updateDoc(challengeDocRef, updatedData);

        console.log('Accepted challenge updated successfully.');
    } catch (error) {
        console.error('Error updating accepted challenge: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const updateMyChallenge = async (challengeId, updatedData) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        // Reference to the specific document using its ID
        const challengeDocRef = doc(challengesCollectionRef, challengeId);

        // Update the document with the new data
        await updateDoc(challengeDocRef, updatedData);

        console.log('Challenge updated successfully.');
    } catch (error) {
        console.error('Error updating challenge: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const deleteAcceptedChallenge = async (challengeId) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const acceptedChallengesCollectionRef = collection(db, 'acceptedChallenges');

        // Reference to the specific document using its ID
        const challengeDocRef = doc(acceptedChallengesCollectionRef, challengeId);

        // Delete the document
        await deleteDoc(challengeDocRef);

        console.log('Accepted challenge deleted successfully.');
    } catch (error) {
        console.error('Error deleting accepted challenge: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getAllChallenges = async () => {
    try {
        // Reference to the "challenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        // Construct a query to retrieve all challenges (no filters in this case)
        const q = query(challengesCollectionRef);

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store challenges
        const challenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            challenges.push({ id: doc.id, ...doc.data() });
        });

        // Log after the challenges have been loaded successfully
        console.log("Challenges successfully loaded....");

        return challenges;
    } catch (error) {
        console.error('Error retrieving challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getChallengeById = async (challengeId) => {
    try {
        // Reference to the specific document in the "challenges" collection
        const challengeDocRef = doc(db, 'challenges', challengeId);

        // Get the document snapshot
        const challengeDoc = await getDoc(challengeDocRef);

        // Check if the document exists
        if (challengeDoc.exists()) {
            // Return the challenge data along with the ID
            return { id: challengeDoc.id, ...challengeDoc.data() };
        } else {
            throw new Error('Challenge not found');
        }
    } catch (error) {
        console.error('Error retrieving challenge: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getUserDoc = async (userId) => {
    try {
        // Reference to the specific document in the "challenges" collection
        const userDocRef = doc(db, 'users', userId);

        // Get the document snapshot
        const userDoc = await getDoc(userDocRef);

        // Check if the document exists
        if (userDoc.exists()) {
            // Return the challenge data along with the ID
            console.log("User document loaded")
            return { id: userDoc.id, ...userDoc.data() };
        } else {
            throw new Error('User not found');
        }
    } catch (error) {
        console.error('Error retrieving User: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const postUserDoc = async (userId, updatedData) => {
    try {
        // Reference to the "users" collection
        const userDocsCollectionRef = collection(db, 'users');

        // Reference to the specific document using its ID
        const userDocRef = doc(userDocsCollectionRef, userId);

        // Update the document with the provided data
        await updateDoc(userDocRef, updatedData);

        console.log('User doc updated successfully.');

        return 1
    } catch (error) {
        console.error('Error updating user document: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
}

export const countChallengesForChannel = async (UID) => {
    try {
        // Reference to the "challenges" collection
        const challengesRef = collection(db, 'challenges');

        // Create a query to find documents where channelID matches the input
        const challengesQuery = query(
            challengesRef,
            where('userID', '==', UID),            
            where('publicFlag', '==', true),            
        );

        // Execute the query to get a snapshot of matching documents
        const challengesSnapshot = await getDocs(challengesQuery);

        // Return the number of documents that match the query
        return challengesSnapshot.size;
    } catch (error) {
        console.error('Error counting challenges for channel: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getTags = async () => {
    try {
        // Reference to the "tags" collection
        const tagsCollectionRef = collection(db, 'tags');

        // Construct a query to retrieve tags with the specific condition
        const q = query(tagsCollectionRef, where('id', '==', 'Sep5'));

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store the tags
        const tags = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            tags.push({ id: doc.id, ...doc.data() });
        });

        return tags;
    } catch (error) {
        console.error('Error retrieving tags:', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const resetUserPassword = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        return { success: true };
    } catch (error) {
        console.error("Error sending password reset email: ", error);
        return { success: false, error: error.message };
    }
};

export const countLiveChallenges = async (currentUserID) => {
    try {
        const challengesRef = collection(db, 'challenges'); // Replace 'challenges' with your actual collection name
        const q = query(
            challengesRef,
            where('uniqueId_influencer', '==', currentUserID),
            where('isLive', '==', true)
        );

        const querySnapshot = await getDocs(q);
        const count = querySnapshot.size; // Returns the number of documents that match the query

        return count;
    } catch (error) {
        console.error("Error counting live challenges: ", error);
        return 0; // Return 0 or handle error appropriately
    }
};

export const addEmailToFirestore = async (formData) => {
    try {
        // Add form data to Firestore 'email' collection
        await addDoc(collection(db, 'email'), {
            name: formData.name,
            email: formData.email,
            subject: formData.subject,
            message: formData.message,
            datePosted: serverTimestamp(),  // Auto-generated timestamp
        });
        console.log("Email posted successfully:", formData);
    } catch (error) {
        console.error("Error posting email to Firestore:", error);
        throw new Error(error.message); // Rethrow error for further handling if needed
    }
};

export const addCareerInterestEmailToFirestore = async (formData) => {
    try {
        // Add form data to Firestore 'emailCareerInterest' collection
        await addDoc(collection(db, 'emailCareerInterest'), {
            name: formData.name,
            email: formData.email,
            subject: formData.subject,
            message: formData.message,
            education: formData.education,
            workExperience: formData.workExperience,
            location: formData.location,
            link: formData.link,
            datePosted: serverTimestamp(),  // Auto-generated timestamp
        });
        console.log("Email posted successfully:", formData);
    } catch (error) {
        console.error("Error posting email to Firestore:", error);
        throw new Error(error.message); // Rethrow error for further handling if needed
    }
};

export const addSearchedValue = async (userID, searchValue) => {
    try {
        await addDoc(collection(db, 'searches'), {
            userID: userID,
            searchValue: searchValue,
            datePosted: serverTimestamp()
        });
        console.log("Search posted");
    } catch (error) {
        console.error("Error posting search value", error);
        throw new Error(error.message); // Rethrow error for further handling if needed
    }
};

export const getMyChannelsForUser = async (userID) => {
    try {
        // Reference to the "acceptedChallenges" collection
        const myChannelsCollectionRef = collection(db, 'channels');

        const today = new Date();
        today.setDate(today.getDate());

        // Construct a query to retrieve accepted challenges based on user ID and date
        const q = query(myChannelsCollectionRef,
            where('userID', '==', userID), // Filter by user ID
            // where('last_day', '>=', today) // Filter by end date greater than or equal to today's date
        );

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store accepted challenges
        const myChannels = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            myChannels.push({ id: doc.id, ...doc.data() });
        });

        return myChannels;

    } catch (error) {
        console.error('Error retrieving my challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const uploadChannelDocument = async (channelObject) => {
    try {
        // Reference to the "channels" collection and generate a new document reference (with ID)
        const docRef = doc(collection(db, 'channels'));

        // Set the document using the generated ID and include the ID in the document object
        await setDoc(docRef, {
            ...channelObject,
            id: docRef.id, // Include the autogenerated ID in the document
            createdAt: serverTimestamp()
        });

        console.log('Channel posted successfully with ID:', docRef.id);
    } catch (error) {
        console.error('Error uploading created channel:', error);
    }
};

export const postChannelDoc = async (channelId, updatedData) => {
    try {
        // Reference to the "users" collection
        const channelsDocCollecitonRef = collection(db, 'channels');

        // Reference to the specific document using its ID
        const channelDocRef = doc(channelsDocCollecitonRef, channelId);

        // Update the document with the provided data
        await updateDoc(channelDocRef, updatedData);

        console.log('Channel doc updated successfully.');
    } catch (error) {
        console.error('Error updating Channel document: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
}

export const getChannelDoc = async (channelID) => {
    try {
        // Reference to the "channel" collection
        const channelCollectionRef = collection(db, 'channels');

        // Create a query to find the document where the channel.id matches the channelId
        const q = query(channelCollectionRef, where('id', '==', channelID));

        // Execute the query and get the matching documents
        const querySnapshot = await getDocs(q);

        // Check if we found a matching document
        if (!querySnapshot.empty) {
            // Extract the first document (should only be one in a unique case)
            const channelDoc = querySnapshot.docs[0];

            // Return the channel data along with the ID
            console.log("Channel document loaded");
            return { id: channelDoc.id, ...channelDoc.data() };
        } else {
            throw new Error('Channel not found');
        }
    } catch (error) {
        console.error('Error retrieving Channel: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getMyChallengesForChannel = async (channelID) => {

    try {
        // Reference to the "acceptedChallenges" collection
        const myChallengesCollectionRef = collection(db, 'challenges');

        const today = new Date();
        today.setDate(today.getDate());

        // Construct a query to retrieve accepted challenges based on user ID and date
        const q = query(myChallengesCollectionRef,
            where('channelID', '==', channelID), // Filter by user ID
        );

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store accepted challenges
        const myChallenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            myChallenges.push({ id: doc.id, ...doc.data() });
        });

        return myChallenges;

    } catch (error) {
        console.error('Error retrieving my challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const deleteChannel = async (channelID) => {
    try {
        // Reference to the "challenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        // Query to get all challenges related to this channelID
        const challengesQuery = query(challengesCollectionRef, where('channelID', '==', channelID));
        const challengesSnapshot = await getDocs(challengesQuery);

        // Create an array to store all challenge deletions
        const deleteChallengesPromises = [];

        // Iterate over each challenge and add its deletion to the promises array
        challengesSnapshot.forEach((challengeDoc) => {
            const challengeDocRef = doc(challengesCollectionRef, challengeDoc.id);
            deleteChallengesPromises.push(deleteDoc(challengeDocRef));
        });

        // Wait for all challenges to be deleted
        await Promise.all(deleteChallengesPromises);
        console.log('All challenges related to the channel deleted successfully.');

        // Now proceed to delete the channel itself
        const channelsCollectionRef = collection(db, 'channels');
        const channelDocRef = doc(channelsCollectionRef, channelID);
        await deleteDoc(channelDocRef);

        console.log('Channel deleted successfully.');
    } catch (error) {
        console.error('Error deleting channel and its challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getAllChannels = async () => {
    try {
        // Reference to the "challenges" collection
        const channelsCollectionRef = collection(db, 'channels');

        // Construct a query to retrieve all challenges (no filters in this case)
        const q = query(channelsCollectionRef);

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store challenges
        const channels = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            channels.push({ id: doc.id, ...doc.data() });
        });

        // Log after the challenges have been loaded successfully
        console.log("Channels successfully loaded....");

        return channels;
    } catch (error) {
        console.error('Error retrieving challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};


//Home Page: FEATURED Challenges & Channels
export const getFeaturedChallenges = async () => {
    try {
        // Reference to the "challenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        // Query to retrieve featured challenges where 'featured' is true
        const q = query(challengesCollectionRef, where('featured', '==', true));

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store challenges
        const challenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            challenges.push({ id: doc.id, ...doc.data() });
        });

        // Log after the challenges have been loaded successfully
        console.log("Featured challenges successfully loaded....");

        return challenges;
    } catch (error) {
        console.error('Error retrieving featured challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getFeaturedChannels = async () => {
    try {
        // Reference to the "channels" collection
        const channelsCollectionRef = collection(db, 'channels');

        // Query to retrieve featured channels where 'featured' is true
        const q = query(channelsCollectionRef, where('featured', '==', true));

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store channels
        const channels = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            channels.push({ id: doc.id, ...doc.data() });
        });

        // Log after the channels have been loaded successfully
        console.log("Featured channels successfully loaded....");

        return channels;
    } catch (error) {
        console.error('Error retrieving featured channels: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const getApprovedforPublicChallenges = async () => {
    try {
        // Reference to the "challenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        // Query to retrieve featured challenges where 'featured' is true
        const q = query(challengesCollectionRef, where('approvedForPublic', '==', true));

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store challenges
        const challenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            challenges.push({ id: doc.id, ...doc.data() });
        });

        // Log after the challenges have been loaded successfully
        console.log("Featured challenges successfully loaded....");

        return challenges;
    } catch (error) {
        console.error('Error retrieving featured challenges: ', error);
        throw error; // Propagate the error for handling at a higher level
    }
};

export const fetchChannelImageURL = async (channelID) => {
    try {
        // Reference to the specific channel document
        const channelDocRef = doc(db, 'channels', channelID);

        // Fetch the document
        const channelDoc = await getDoc(channelDocRef);

        if (channelDoc.exists()) {
            // Return the image URL from the document data
            const channelData = channelDoc.data();
            return channelData.imageURL;
        } else {
            console.log("Channel document not found.");
            return null; // Return null if the document doesn't exist
        }
    } catch (error) {
        console.error("Error fetching channel image URL: ", error);
        throw error; // Propagate the error if needed
    }
};


//Searching only for Public Challenges
export const getPublicChallenges = async () => {
    try {
        // Reference to the "challenges" collection
        const challengesCollectionRef = collection(db, 'challenges');

        // Query to retrieve challenges where 'challengeID' exists and 'approvedForPublic' is true
        const q = query(challengesCollectionRef,
            where('publicFlag', '!=', false), // Ensure challengeID is not false
        );

        // Execute the query
        const querySnapshot = await getDocs(q);

        // Initialize an array to store challenges
        const challenges = [];

        // Iterate over the query snapshot and extract data from each document
        querySnapshot.forEach((doc) => {
            challenges.push({ id: doc.id, ...doc.data() });
        });

        return challenges;
    } catch (error) {
        throw error; // Propagate the error for handling at a higher level
    }
};

export const deleteUserAndChallenges = async (userId) => {
    const db = getFirestore();

    try {
        // 1. Delete the user document
        const userDocRef = doc(db, 'users', userId);
        await deleteDoc(userDocRef);

        // 2. Delete all accepted challenges where userID matches the userId
        const acceptedChallengesRef = collection(db, 'acceptedChallenges');
        const acceptedChallengesQuery = query(acceptedChallengesRef, where('userID', '==', userId));
        const acceptedChallengesSnapshot = await getDocs(acceptedChallengesQuery);

        const acceptedChallengesDeletionPromises = acceptedChallengesSnapshot.docs.map((doc) => deleteDoc(doc.ref));
        await Promise.all(acceptedChallengesDeletionPromises);

        // 3. Delete all challenges created by the user
        const challengesRef = collection(db, 'challenges');
        const challengesQuery = query(challengesRef, where('userID', '==', userId));
        const challengesSnapshot = await getDocs(challengesQuery);

        const challengesDeletionPromises = challengesSnapshot.docs.map((doc) => deleteDoc(doc.ref));
        await Promise.all(challengesDeletionPromises);

        // 4. Delete all channels owned by the user
        const channelsRef = collection(db, 'channels');
        const channelsQuery = query(channelsRef, where('userID', '==', userId));
        const channelsSnapshot = await getDocs(channelsQuery);

        const channelsDeletionPromises = channelsSnapshot.docs.map((doc) => deleteDoc(doc.ref));
        await Promise.all(channelsDeletionPromises);

        console.log("User and related challenges successfully deleted.");
    } catch (error) {
        console.error("Error deleting user and challenges: ", error);
    }
};